/* global pendo */
import { extLocalStore } from 'util/localStorage';
import { defaultMetadata } from 'config/pendoConfig.js';

let initialized = false;
const DEMO_TYPES = ['DEMO_NO_UL_SYNC', 'DEMO_YES_UL_SYNC'];

const isDemoCustomer = (customerType) => DEMO_TYPES.includes(customerType);

export const initPendo = (user, role) => {
	/*
    need to get the user info either
    in an API call to platform
		body or from API call

		The commented out meta data is not yet available from calling the, so for now it is commented out.
	  Teams will have to uncomment these lines once [this ticket](https://jira.icims.net/browse/IGN-418) is complete.
    */
	if (!initialized) {
		// eslint-disable-next-line no-undef
		const cloudEnvironment = extLocalStore.getItem('cloudEnv');
		const visitor = {
			id: `ACS-${cloudEnvironment}-${user.id}`,
			userId: user.userName,
			role
		};

		const account = {
			id: `ACS-${cloudEnvironment}-${user.customerId}`,
			customerName: user.customerName,
			salesforceAccountId: user.salesforceAccountId || '',
			// nullish coalescing are features of ES11
			product: user.customerIds[0] ? user.customerIds[0].product : ''
		};

		pendo.initialize({ visitor, account });
		initialized = true;
	}
};

export const track = (trackType, additionalMetadata, customerType) => {
	if (isDemoCustomer(customerType)) {
		return;
	}
	if (initialized) {
		pendo.track(trackType, {
			...defaultMetadata,
			...additionalMetadata
		});
	}
};
